import { omniAtom } from "src/utils/atoms";
import { OpenStorePlanogramReviewModal } from "./hooks";

export const storePlanogramReviewAtom = omniAtom({
  key: "modals/storePlanogramReview",
  value: null as OpenStorePlanogramReviewModal | null,
});
